/**
 * Check if the viewport width is lower or equal to the autocompleteMobileMaxWidth property in the shopConfig.
 *
 * @param {{}} shopConfig The URL to parse.
 * @param {string} shopConfig.autocompleteMobileMaxWidth The URL to parse.
 * @returns {boolean} The device is mobile or not.
 */
function isMobile(shopConfig) {
    let isMobile;
    // Check if within mobile width
    if ('autocompleteMobileMaxWidth' in shopConfig) {
        const mobileMaxWidth = shopConfig.autocompleteMobileMaxWidth;
        isMobile = window.matchMedia('screen and (max-width: ' + mobileMaxWidth + ')').matches;
    } else {
        isMobile = false;
    }

    return isMobile;
}

export default {
    isMobile: isMobile,
};
